import {observable, action} from 'mobx';

export class AddListStore {
  @observable appDatas = [];
  @observable sreenDatas = [];
  @observable whereDatas={type:"project",id:"",name:"复兴"};

  constructor(routing) {
    this.routing = routing;
  }

  @action
  callAppData(id) {
    setTimeout(()=>{
      this.appDatas = require("../../mocks/datas_"+id+".json");
    },300);
  }

  callScreenData(id) {
    setTimeout(()=>{
      this.sreenDatas = require("../../mocks/screen_"+id+".json");
    },300);
  }

  callAddWhereData(params,filter){
    let where = '';
    if(params === '2'){
      this.addModal={...this.addModal,addWhere:'2',title:'项目',cloumns:[{
                                                title: '项目名称',
                                                dataIndex: 'name',
                                              }, {
                                                title: '项目类别',
                                                dataIndex: 'type',
                                              }]
                    }
      where = 'proj';
    }else if(params === '3'){
      this.addModal={...this.addModal,addWhere:'3',title:'方案',cloumns:[{
                                                title: '方案名称',
                                                dataIndex: 'name',
                                              }]
                    }
      where='scheme';
    }
    setTimeout(()=>{
      this.addModal = {...this.addModal,datas:require("../../mocks/datas_where_"+where+".json")};
      if(filter&&filter!==""){
        console.log("filter:",filter);
        let temp=[];
        this.addModal.datas.filter(function(el) {
          if(el&&el.name.indexOf(filter)>=0){
            console.log("el1:",el);
            temp.push(el);
          }          
        });
        this.addModal={...this.addModal,datas:temp};  
      }
      this.addModal={...this.addModal,visible:true};
    },300);  
  }

  callToAddAPP(app,where){
    //??todo:添加应用到相应选择
    console.log("----callToAddAPP",app,where);
  }

}


// WEBPACK FOOTER //
// ./src/stores/addList/AddListStore.js